import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';

export type PortalioSelectAllListItemProps = {
  showSelectAll?: boolean;
  onSelectAll: () => void;
  selectedAll: boolean;
  proposalsLength: number | undefined;
  selectedProposalsCount: number;
};

export const PortalioSelectAllListItem = ({
  showSelectAll,
  onSelectAll,
  selectedAll,
  proposalsLength,
  selectedProposalsCount,
}: PortalioSelectAllListItemProps) => {
  const theme = useTheme();

  if (!showSelectAll) {
    return null;
  }

  return (
    <ListItem key="select-all" dense disableGutters disablePadding>
      <ListItemButton role={undefined} onClick={onSelectAll} disableRipple>
        <ListItemIcon
          sx={{
            minWidth: theme.spacing(4),
          }}
        >
          <Checkbox
            edge="start"
            checked={selectedAll}
            tabIndex={-1}
            disableRipple
            size="small"
            indeterminate={
              proposalsLength !== selectedProposalsCount && selectedProposalsCount > 0
            }
            slotProps={{
              input: {
                'aria-labelledby': 'select-all-option',
              },
            }}
          />
        </ListItemIcon>
        <ListItemText id="select-all-option" primary="Select all visible" />
      </ListItemButton>
    </ListItem>
  );
};
